import { Box, Button, Stack, Typography, styled } from '@mui/material';

export const StyledPickerModeContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const StyledPickerModeButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: theme.spacing(2),
  gap: theme.spacing(1),
  background: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  '&:hover': {
    background: theme.palette.grey[200],
  },
}));

export const StyledPickerModeButtonInner = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
}));

export const StyledIconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.secondary.dark,
  borderRadius: theme.spacing(0.5),
  color: theme.palette.grey[50],
}));

export const StyledPickerModeButtonTitle = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.grey[900],
  textAlign: 'left',
}));

export const StyledPickerModeButtonDescription = styled(Typography)(
  ({ theme }) => ({
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.grey[600],
  })
);
